import TrainerInfoCheckItem from './TrainerInfoCheckItem';

export default function TrainerInfoCoaching({ value }) {
  return <TrainerInfoCheckItem label="Coaching" value={value} />;
}
